import React, { Fragment, useContext, useMemo } from 'react'
import { IproviderFundAcc, ProviderFundAccount } from './FundAccoutingForm';
import { useFieldArray } from 'react-hook-form';
import _ from "lodash";
import { parseFloatCheckValue } from '../Ticket/fnTickit';
import { Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { BtnAdd, BtnDeleteTable } from 'components/Button/ButtonAll';
import { I18n } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';
import InputReactNumber from '../InputReactNumber';
import { ItemFundAcc } from './interfaceFundAcc';
import { TextBoxItem } from 'components/Input/TextBox';

export const TableIncome = () => {

    const {
        isView,
        DialogFn,
        form,
        findValue,
        findMaxID,
        setEqualBalance
    } = useContext<IproviderFundAcc>(ProviderFundAccount);


    const { control, watch } = form;
    const { fields } = useFieldArray({
        control,
        name: "lstIncome"
    });

    const watchFieldArray = watch("lstIncome");

    const controlledFields = useMemo(() => {
        return fields.map((field, index) => {
            return {
                ...field,
                ...watchFieldArray[index]
            };
        });
    }, [fields, watchFieldArray])

    const handleAdd = (dataRow: ItemFundAcc, nParentID: number | null) => {
        let lstIncome = watch("lstIncome");
        // let deepCopy = _.cloneDeep(lstIncome) as ItemFundAcc[];
        let deepCopy = lstIncome;
        let nOrderMax = findMaxID(deepCopy);
        // Add In Sub Level
        let rowEdit: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", dataRow.nOrder);
        if (rowEdit) {
            // let lstCloneSubLevel = _.cloneDeep(rowEdit.lstSubLevel) as ItemFundAcc[];
            let objAdd = {
                nID: null,
                nOrder: nOrderMax,
                sName: null,
                isCanAdd: true,
                isCanDelete: true,
                isDelete: false,
                isDisable: false,
                sTotal: null,
                lstSubLevel: [],
            } as ItemFundAcc

            if (!nParentID) {
                rowEdit.lstSubLevel = rowEdit.lstSubLevel || []
                rowEdit.lstSubLevel.splice(0, 0, objAdd);
                form.setValue("lstIncome", deepCopy);
                form.reset({
                    ...form.watch(),
                    lstIncome : deepCopy
                });
                return;
            }

            //Find Index on handle
            let rowParent: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", nParentID);
            if (rowParent) {
                let nIndex = rowParent.lstSubLevel.findIndex(f => f.nOrder === dataRow.nOrder);
                if (nIndex > -1) {
                    rowParent.lstSubLevel.splice(nIndex + 1, 0, objAdd);
                }
            }
            form.setValue("lstIncome", deepCopy);
            form.reset({
                ...form.watch(),
                lstIncome : deepCopy
            });
        }
    }

    const calculateIncome = (value: any, nParentID: number | null) => {
        // if (!value) {
        //     return;
        // }
        let lstIncome = _.cloneDeep(watch("lstIncome")) as ItemFundAcc[];

        if (nParentID) {
            lstIncome.forEach((element: ItemFundAcc, index: number) => {
                if (element.nOrder === nParentID && element.lstSubLevel != null && element.lstSubLevel.length !== 0) {
                    let sum = _.sumBy(element.lstSubLevel, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
                    element.sTotal = sum + "";
                    form.setValue(`lstIncome.${index}.sTotal`, sum + "")
                }
            });
        }

        let sumIncome = _.sumBy(lstIncome, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
        sumIncome = Number(sumIncome.toFixed(2));

        form.setValue("sTotalIncome", sumIncome + "")

        let nBringForward = parseFloatCheckValue(form.getValues("sBringForward")) ?? 0;
        let nTotalExpense = parseFloatCheckValue(form.getValues("sTotalExpense")) ?? 0;
        let calBalance = nBringForward + sumIncome - nTotalExpense;
        form.setValue("sBalance", calBalance + "")

        let nTotalMoreDetail  = parseFloatCheckValue(form.getValues("sTotalMoreDetail")) ?? 0;
        setEqualBalance(calBalance === nTotalMoreDetail)

    }

    const handleAddParent = () => {
        let lstIncome = watch("lstIncome");
        let deepCopy = _.cloneDeep(lstIncome) as ItemFundAcc[];
        let nOrderMax = findMaxID(deepCopy);
        // Add Parent
        deepCopy.push({
            nID: null,
            nOrder: nOrderMax,
            nFundAccountingItemID: null,
            sName: null,
            isCanAdd: true,
            isCanDelete: true,
            isDelete: false,
            isDisable: false,
            sTotal: null,
            lstSubLevel: [],
        })

        form.setValue("lstIncome", deepCopy);
    }

    const handleDelete = (dataRow: ItemFundAcc) => {

        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            let lstIncome = watch("lstIncome");
            let deepCopy = _.cloneDeep(lstIncome) as ItemFundAcc[];
            let dtDelete: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", dataRow.nOrder);
            dtDelete.isDelete = true;
            const cleanIsDeleteInArray = removeDeletedItems(deepCopy);
            cleanIsDeleteInArray.forEach((element: ItemFundAcc, index: number) => {
                if (element.lstSubLevel != null && element.lstSubLevel.length !== 0) {
                    let sum = _.sumBy(element.lstSubLevel, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
                    element.sTotal = sum + "";
                    form.setValue(`lstIncome.${index}.sTotal`, sum + "")
                }
            });
            let sumIncome = _.sumBy(cleanIsDeleteInArray,  (o: ItemFundAcc) => { return parseFloatCheckValue(o.sTotal); });
            form.setValue("sTotalIncome", sumIncome + "")

            form.setValue("lstIncome", cleanIsDeleteInArray);
            DialogFn.CloseSubmit();
        });
    }

    const removeDeletedItems = (arr: ItemFundAcc[]) => {
        return arr.filter(item => !item.isDelete).map(item => {
            if (item.lstSubLevel && item.lstSubLevel.length > 0) {
                item.lstSubLevel = removeDeletedItems(item.lstSubLevel);
            }
            return item;
        });
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Divider textAlign="left" className="font-weight-500">รายการรายรับ</Divider>
            </Grid>
            <Grid item xs={12}>
                {/* Table */}
                <TableContainer id='table-fundacc' component={Paper}>
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                                <TableCell component="th" padding='none' >รายการ</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '200px', width: '200px' }}>จำนวนเงิน (บาท)</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                controlledFields.map((row, index) => {
                                    const fieldName = `lstIncome.${index}`;
                                    let isHasSubLevel = row.lstSubLevel != null && row.lstSubLevel.length > 0;
                                    return (
                                        <Fragment key={`${fieldName}.sID`}>
                                            <TableRow key={`${fieldName}.sID`} sx={{ backgroundColor: "#f2f2f2" }}>
                                                <TableCell align="center" >{index + 1}</TableCell>
                                                <TableCell align="left">
                                                    {
                                                        row.isCanAdd && row.nID !== 8 ?
                                                            <TextBoxItem
                                                                id={`${fieldName}.sName`}
                                                                name={`${fieldName}.sName`}
                                                                label=""
                                                                required={true}
                                                                maxLength={250}
                                                                IsShowMessageError={false}
                                                                disabled={row.isDisable || isView}
                                                            />
                                                            :
                                                            row.sName
                                                    }

                                                </TableCell>
                                                <TableCell align="right">
                                                    <InputReactNumber
                                                        id={`${fieldName}.sTotal`}
                                                        name={`${fieldName}.sTotal`}
                                                        defaultValue={row.sTotal}
                                                        required={false}
                                                        maxLength={16}
                                                        maxDigits={2}
                                                        valueType='string'
                                                        IsCanMinus={false}
                                                        IsShowMessageError={false}
                                                        disabled={row.isDisable || isView || isHasSubLevel}
                                                        onChange={(value) => {
                                                            calculateIncome(value, null)
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.isCanAdd && !isView && <BtnAdd id={`btnAddIncome${index}`} IsCircleWithOutText onClick={() => { handleAdd(row, null) }} />}
                                                    &nbsp;
                                                    {row.isCanDelete && !isView && <BtnDeleteTable id={`btnDeleteIncome${index}`} IsCircleWithOutText onClick={() => { handleDelete(row); }} />}
                                                </TableCell>
                                            </TableRow>
                                            {
                                                isHasSubLevel ?
                                                    <>
                                                        {
                                                            row.lstSubLevel.map((subRow, subIndex) => {
                                                                const subFieldName = `lstIncome.${index}.lstSubLevel.${subIndex}`;
                                                                return (
                                                                    <TableRow key={`${subFieldName}.sID`}>
                                                                        <TableCell align="center" ></TableCell>
                                                                        <TableCell align="left" sx={{ paddingLeft: '40px !important' }}>
                                                                            {
                                                                                subRow.isCanAdd ?
                                                                                    <TextBoxItem
                                                                                        id={`${subFieldName}.sName`}
                                                                                        name={`${subFieldName}.sName`}
                                                                                        label=""
                                                                                        required={true}
                                                                                        maxLength={250}
                                                                                        disabled={subRow.isDisable || isView}
                                                                                        IsShowMessageError={false}
                                                                                    />
                                                                                    :
                                                                                    subRow.sName
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            <InputReactNumber
                                                                                id={`${subFieldName}.sTotal`}
                                                                                name={`${subFieldName}.sTotal`}
                                                                                defaultValue={subRow.sTotal}
                                                                                required={false}
                                                                                maxLength={16}
                                                                                maxDigits={2}
                                                                                valueType='string'
                                                                                IsCanMinus={false}
                                                                                disabled={subRow.isDisable || isView}
                                                                                IsShowMessageError={false}
                                                                                onChange={(value) => {
                                                                                    calculateIncome(value, row.nOrder)
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            {subRow.isCanAdd && !isView  && <BtnAdd id={`btnAddSubIncome${index}`} IsCircleWithOutText onClick={() => { handleAdd(subRow, row.nOrder) }} />}
                                                                            &nbsp;
                                                                            {subRow.isCanDelete && !isView && <BtnDeleteTable id={`btnDeleteSubIncome${index}`} IsCircleWithOutText onClick={() => { handleDelete(subRow); }} />}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        }
                                                    </> : null
                                            }
                                        </Fragment>

                                    )
                                })
                            }
                            {
                                controlledFields.length === 0 ?
                                    <TableRow >
                                        <TableCell align="center" colSpan={4}>ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                    :
                                    null
                            }
                            <TableRow sx={{ backgroundColor: "#e8be2a" }}>
                                <TableCell align="center" component="td" ></TableCell>
                                <TableCell align="center" component="td">รวมรายรับ</TableCell>
                                <TableCell component="td" className='text-right'>
                                    <InputReactNumber
                                        id={`sTotalIncome`}
                                        name={`sTotalIncome`}
                                        required={false}
                                        maxDigits={2}
                                        IsCanMinus={false}
                                        valueType='string'
                                        IsShowMessageError={false}
                                        disabled
                                    />
                                </TableCell>
                                <TableCell align="center" component="td" ></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item xs={12}>
                {/* buttun Add */}
                {!isView && <BtnAdd id="btnAdd-income" txt="เพิ่มรายการรายรับ" onClick={() => { handleAddParent() }} />}
            </Grid>
        </Grid>
    )
}
